
  import { Vue, Component, Prop } from "vue-property-decorator";
  import GET_MANAGERS from "@/apollo/autocomplete-queries/GetManagers.gql";
  import GET_MANAGERS_WITH_PRIVATE_DATA from "@/apollo/autocomplete-queries/GetManagersWithPrivateData.gql";
  import DropdownOption from "@/entities/DropdownOption";
  import { Manager, Query_RootManagerArgs } from "@/generated/graphql";
  import getMultiselectEmployees from "@/helpers/getMultiselectEmployees";
  import EmployeeDropdownOption from "@/entities/EmployeeDropdownOption";
  import EmployeeMultiselect from "@/components/autocompleteMultiselects/EmployeeMultiselect.vue";
  import getUserFullData from "@/helpers/getUserFullData";

  @Component({
    components: {
      EmployeeMultiselect,
    },
    apollo: {
      managersPublic: {
        query: GET_MANAGERS,
        variables() {
          return this.managerAutocompleteFilter;
        },
        update(data) {
          return data.manager;
        },
        skip() {
          return this.withEmailSearch;
        },
      },
      managersPrivate: {
        query: GET_MANAGERS_WITH_PRIVATE_DATA,
        variables() {
          return this.managerAutocompleteFilter;
        },
        update(data) {
          return data.manager;
        },
        skip() {
          return !this.withEmailSearch;
        },
      },
    },
  })
  export default class ManagersMultiselect extends Vue {
    @Prop({ default: () => [], type: Array }) value!: string[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
    @Prop({ default: true, type: Boolean }) multiple!: boolean;
    @Prop({ default: "", type: String }) readonly selectLabel!: string;
    @Prop({ default: "", type: String }) readonly deselectLabel!: string;
    @Prop({ default: "Managers", type: String }) readonly placeholder!: string;
    @Prop({ default: false, type: Boolean }) readonly invalid!: boolean;
    @Prop({ type: Boolean, default: false }) readonly withEmailSearch!: boolean;
    @Prop({ type: Object, default: () => ({}) }) readonly additionalConditions!: Object;
    @Prop({ type: Boolean, default: false }) disabled!: boolean;

    managersPublic: Manager[] = [];
    managersPrivate: Manager[] = [];
    managerSearchString = "";

    get managers(): Manager[] {
      if (this.withEmailSearch) {
        return this.managersPrivate;
      }
      return this.managersPublic;
    }

    get isLoading(): boolean {
      const { managersPublic, managersPrivate } = this.$apollo.queries;
      if (this.withEmailSearch) {
        return managersPrivate.loading;
      }
      return managersPublic.loading;
    }

    get placeholderText(): string {
      return this.placeholder ? this.placeholder : "Select manager";
    }

    get managersOptions(): any {
      return getMultiselectEmployees({
        employees: this.managers,
        search: this.managerSearchString,
        withEmailSearch: this.withEmailSearch,
      });
    }

    get managerAutocompleteFilter(): Query_RootManagerArgs {
      const conditions: any[] = [this.additionalConditions];
      return {
        where: { _and: conditions },
      };
    }

    get chosenManagers(): EmployeeDropdownOption[] {
      return this.managers
        .filter(manager => this.value.some(managerId => manager.id === managerId))
        .map(manager => {
          const { id, user } = manager;
          const { given_name, family_name, avatar = "" } = user;
          const email = user.private_data?.email;

          return {
            id,
            name: getUserFullData(given_name!, family_name!, email!),
            given_name,
            family_name,
            avatar,
          } as EmployeeDropdownOption;
        });
    }

    handleInput(managers: DropdownOption[]) {
      const managersIds =  managers.map(manager => manager.id);
      this.$emit("input", managersIds);
    }
  }
